import React, { useState } from "react"

//assets
import slug, { topicSlug } from "../slug"
import Arrow from "../../assets/wg/arrow.svg"

//styles
import * as Styled from "./popup.styles"

const PopupNavigation = ({ location, show }) => {
  const [active, showSubmenu] = useState(false)
  const [activeThemenSubmenu, showThemenSubmenu] = useState(false)

  const checkCurPath = path => {
    if (location.pathname.replaceAll) {
      const s = location.pathname.replaceAll("/", "")
      const temp = path.replaceAll("/", "")
      return s.localeCompare(temp) === 0 ? 1 : 0
    } else {
      return 0
    }
  }

  return (
    <Styled.ResponsiveMenuContainer show={show}>
      <Styled.ResponsiveMenu show={show}>
        <li>
          <h2>Menü</h2>
        </li>
        <li>
          <Styled.GatsbyLink to="/" active={checkCurPath("/")}>
            Startseite
          </Styled.GatsbyLink>
        </li>
        <li>
          <Styled.LeistungsButtonContainer
            active={
              checkCurPath(slug[0]) ||
              checkCurPath(slug[1]) ||
              checkCurPath(slug[2])
            }
            show={active}
          >
            <Styled.LeistungenButton
              onClick={() => {
                showSubmenu(!active)
                showThemenSubmenu(false)
              }}
            >
              <span>Leistungen</span>
            </Styled.LeistungenButton>
            <Arrow />
            <Styled.Submenu active={active}>
              <li>
                <Styled.GatsbyLink to={slug[0]} active={checkCurPath(slug[0])}>
                  Wohngemeinschaft
                </Styled.GatsbyLink>
              </li>
              <li>
                <Styled.GatsbyLink to={slug[2]} active={checkCurPath(slug[2])}>
                  Ambulante Pflege
                </Styled.GatsbyLink>
              </li>
              <li>
                <Styled.GatsbyLink to={slug[1]} active={checkCurPath(slug[1])}>
                  Tagesstätte
                </Styled.GatsbyLink>
              </li>
            </Styled.Submenu>
          </Styled.LeistungsButtonContainer>
        </li>
        <li>
          <Styled.LeistungsButtonContainer
            bigger
            active={
              checkCurPath(
                topicSlug[
                  "moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld"
                ]
              ) ||
              checkCurPath(
                topicSlug["voraussetzungen-und-leistungen-der-pflegegrade"]
              )
            }
            show={activeThemenSubmenu}
          >
            <Styled.LeistungenButton
              onClick={() => {
                showThemenSubmenu(!activeThemenSubmenu)
                showSubmenu(false)
              }}
            >
              <span>Pflegethemen</span>
            </Styled.LeistungenButton>
            <Arrow />
            <Styled.Submenu active={activeThemenSubmenu}>
              <li>
                <Styled.GatsbyLink
                  to={
                    topicSlug[
                      "moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld"
                    ]
                  }
                  active={checkCurPath(
                    topicSlug[
                      "moeglichkeiten-zur-finanziellen-unterstuetzung-und-leistungen-fuer-die-pflege-im-gewohnten-umfeld"
                    ]
                  )}
                >
                  Finanzielle Unterstützung und Leistungen für die Pflege im
                  gewohnten Umfeld
                </Styled.GatsbyLink>
              </li>
              <li>
                <Styled.GatsbyLink
                  to={
                    topicSlug["voraussetzungen-und-leistungen-der-pflegegrade"]
                  }
                  active={checkCurPath(
                    topicSlug["voraussetzungen-und-leistungen-der-pflegegrade"]
                  )}
                >
                  Voraussetzungen und Leistungen der Pflegegrade
                </Styled.GatsbyLink>
              </li>
            </Styled.Submenu>
          </Styled.LeistungsButtonContainer>
        </li>
        <li>
          <Styled.GatsbyLink to={slug[3]} active={checkCurPath(slug[3])}>
            Team
          </Styled.GatsbyLink>
        </li>
        <li>
          <Styled.GatsbyLink to={slug[4]} active={checkCurPath(slug[4])}>
            Karriere
          </Styled.GatsbyLink>
        </li>
        <li>
          <Styled.GatsbyLink to="/kontakt" active={checkCurPath("/kontakt")}>
            Kontakt
          </Styled.GatsbyLink>
        </li>
      </Styled.ResponsiveMenu>
    </Styled.ResponsiveMenuContainer>
  )
}

export default PopupNavigation
